export enum EntitySpacesApiTags {
  spacesList = "spacesList",
}
